<template>
  <div class="comp-agency-tree-core">
    <el-input
      @input="handleFilter"
      v-model="filterText"
      :clearable="true"
      class="search-input"
      placeholder="请输入机构名称">
      <i slot="suffix" class="el-input__icon el-icon-search"></i>
    </el-input>
    <a href="javascript:void(0);" class="more" @click="handleShowMore" v-if="hasFilter">更多</a>
    <hr v-if="hasFilter"/>
    <div class="el-tree" :style="{height:this.contentHeight + 'px'}">
      <div :style="{height:height +'px'}">
        <div v-for="(item,index) in visibleData"
             :key="index"
             :style="{'padding-left':item.level * 20 + (item.children.length ? 0 : 24) + 'px',position: 'absolute','top': item.paddingTop+'px'}">
          <div class="el-tree-node__content">
            <span
              class="el-tree-node__expand-icon el-icon-caret-right"
              :class="{expanded:item.expanded}"
              v-if="item.children.length > 0"
              @click="handleExpand(item)"></span>
            <div class="el-checkbox__input" :class="item.checkClass">
              <span class="el-checkbox__inner" @click="handleCheckChange(item)"></span>
            </div>
            <span class="el-tree-node__label" @click="handleCheckChange(item)">{{item.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getChildrenLength, getDataById} from './agencyUtils';

  export default {
    props: {
      'treeData': {
        type: Array
      },
      'isCRMUser': {
        type: Boolean,
        default: true
      },
      'hasFilter': {
        type: Boolean,
        default: true
      },
      'filterNodeMethod': {
        type: Function,
        default: function (item, filterText) {
          return true;
        }
      },
      'content-height': {
        type: Number,
        default: 360
      }
    },
    name: 'popover',
    data () {
      return {
        visible: false,
        inputValue: '',
        filterText: '',
        height: 0,
        visibleData: []
      };
    },
    mounted () {
      let that = this;
      this.$el.getElementsByClassName('el-tree')[0].addEventListener('scroll', function () {
        if (/macintosh/i.test(navigator.userAgent)) {
          setTimeout(() => {
            that.update();
          }, 0);
        } else {
          that.update();
        }
      });
      this.update();
    },
    created () {
      this.caclHeight();
    },
    methods: {
      caclHeight () {
        this.height = this.treeData.length * 26;
      },
      handleExpand (val) {
        let count = getChildrenLength(val);
        const startIndex = val.index;
        this.treeData[startIndex].expanded = !val.expanded;
        if (val.expanded) {
          this.height = this.height + count * 26;
        } else {
          this.height = this.height - count * 26;
        }
        this.update();
      },
      //多选树，check节点
      handleCheckChange (cData, cNewCheckStatus) {
        let items = Object.prototype.toString.call(cData) === '[object Array]' ? cData : [cData];
        items.forEach((val) => {
          const checkStatus = val.checkStatus;
          const oCheckStatus = checkStatus.checked;
          const nCheckStatus = cNewCheckStatus === true ? 2 : (checkStatus.checked === 2 ? 0 : 2);
          //往父级前找
          this._checkParentChecked(val, oCheckStatus, nCheckStatus);
          //往子级找
          const index = val.index;
          for (let i = index, length = getChildrenLength(val) + index; i <= length; i++) {
            this.treeData[i].checkStatus.checked = nCheckStatus;
            this.treeData[i].checkStatus.childChecked = nCheckStatus === 0 ?
              [this.treeData[i].children.length, 0, 0] : [0, 0, this.treeData[i].children.length];
          }
        });
        this.update();

        let selectedAgencies = [];
        this.treeData.forEach((item) => {
          const id = item.id;
          const data = getDataById(this.treeData, id);
          if (data && data.checkStatus.checked === 2) {
            if (this.isCRMUser) {
              item.hotelId && selectedAgencies.push(item);
            } else {
              item.hotelId && item.disable === false && selectedAgencies.push(item);
            }
          }
        });
        this.$emit('checkAgencyLeaves', selectedAgencies);
      },
      _checkParentChecked (item, oCheckStatus, nCheckStatus) {
        if (oCheckStatus === nCheckStatus) {
          return;
        }
        const parentItem = this.treeData[item.pIndex];
        if (!parentItem) {
          return;
        }
        const parentCheckStatus = parentItem.checkStatus;
        const pOCheckStatus = parentCheckStatus.checked;
        let pNCheckStatus = null;

        parentCheckStatus.childChecked[oCheckStatus]--;
        parentCheckStatus.childChecked[nCheckStatus]++;

        if (parentCheckStatus.childChecked[0] === parentCheckStatus.childLength) {
          pNCheckStatus = 0;
          parentCheckStatus.checked = 0;
        } else if (parentCheckStatus.childChecked[2] === parentCheckStatus.childLength) {
          pNCheckStatus = 2;
          parentCheckStatus.checked = 2;
        } else {
          pNCheckStatus = 1;
          parentCheckStatus.checked = 1;
        }
        this._checkParentChecked(parentItem, pOCheckStatus, pNCheckStatus);
      },
      handleFilter () {

        const parentMap = {};//用于存放自己没通过过滤，但子元素通过过滤的条目
        let count = 0;
        for (let i = this.treeData.length - 1; i >= 0; i--) {
          const item = this.treeData[i];
          let isFilter = false;
          if (parentMap[item.index] === true) {
            isFilter = true;
            item.visible = true;
            count++;
          } else {
            isFilter = this.filterNodeMethod(item, this.filterText);
            if (isFilter) {
              count++;
            }
            item.visible = isFilter;
          }
          if (isFilter && this.treeData[item.pIndex]) {
            parentMap[item.pIndex] = true;
          }
        }
        this.height = count * 26;
        this.update();
      },
      //全选
      selectAll (onlyHotels = true) {
        if (onlyHotels) {
          const ids = [];
          this.treeData.forEach((item) => {
            if (item.type === 3) {
              ids.push(item.id);
            }
          });
          this.setAgency(ids);
        } else {
          this.setAgency([this.treeData[0].id]);
        }
      },

      //单选树，点击node
      handleClickNode (agency) {
        if (agency) {
          if ((!this.isCRMUser && agency.type === 4 && agency.disable === false) || (agency.type === 3 && this.isCRMUser)) {
            this.inputValue = `${agency.name}`;
            this.visible = false;
            this.$emit('checkAgencyLeaves', [agency]);
          }
        } else {
          this.inputValue = '';
        }
      },

      update () {
        const scrollTop = this.$el.getElementsByClassName('el-tree')[0].scrollTop;
        let count = scrollTop ? Math.floor(scrollTop / 26) : -1;
        let showIndex = count + 1;
        const leftHeight = scrollTop - count * 26;
        //对于已经移除显示范围的条目，如果有收缩的条目，则实际滚出显示区的数量为getChildrenLength()
        for (let i = 0; i < count; i++) {
          if (this.treeData[i].expanded === false) {
            count += getChildrenLength(this.treeData[i]);
          }
        }
        const vData = [];
        for (let i = count + 1; i < this.treeData.length; i++) {
          if (vData.length === 50) {
            break;
          }
          if (this.treeData[i].visible === false) {
            continue;
          }
          const id = this.treeData[i].id;
          this.treeData[i].paddingTop = 26 * (showIndex++) - (26-leftHeight);
          const checkStatus = this.treeData[i].checkStatus.checked;
          this.treeData[i].checkClass = checkStatus === 0 ? ''
            : (checkStatus === 2 ? 'is-checked' : 'is-indeterminate');
          vData.push(this.treeData[i]);
          if (this.treeData[i].expanded === false) {
            i += getChildrenLength(this.treeData[i]);
          }
        }
        if (vData.length !== 0 && vData[vData.length - 1].paddingTop + 26 > this.height) {
          this.height = vData[vData.length - 1].paddingTop + 26;
        }
        this.visibleData = vData;
      },
      setAgency (agencies) {
        this.treeData.forEach((item) => {
          item.checkStatus.checked = 0;
          item.checkStatus.childChecked = [item.checkStatus.childLength, 0, 0];
        });
        const datas = [];
        agencies.forEach((id) => {
          const data = getDataById(this.treeData, id);
          data && datas.push(data);
        });
        this.handleCheckChange(datas, true);
      },
      setAgencyByHotelId (hotelId) {
        let agencies = this.getIdByHotelId(hotelId);
        if (this.checkable) {
          agencies = agencies || [];
          this.$refs.tree.setCheckedKeys(agencies);
        } else {
          if (agencies === undefined) {
            this.$emit('nodeClick');
            this.$refs.tree.store.currentNode = null;
          } else {
            let curNode = this.$refs.tree.store.nodesMap[agencies].data;
            this.$emit('nodeClick', curNode);
          }
        }
      },
      getIdByHotelId (hotelId) {
        let item = this.orgTree.filter(item => +item.hotelId === +hotelId);
        if (item.length > 0) {
          return item[0].id;
        } else {
          return undefined;
        }
      },
      clearFilter () {
        this.filterText = '';
        this.handleFilter();
      },
      handleShowMore () {
        this.$emit('showMore');
      }
    }
  };
</script>

<style lang="less">
  .comp-agency-tree-core {
    .trigger-input input {
      width: 250px !important;
      cursor: pointer;
    }
    .search-input {
      margin: 5px;
      width: 200px;
      display: inline-block;
      input {
        width: 228px;
        height: 30px;
      }
    }
    .el-input__icon {
      line-height: 30px;
    }
    .more {
      font-size: 12px;
      color: #016CDF;
      letter-spacing: 0;
      line-height: 20px;
      margin-left: 3px;
    }
    hr {
      border-top: 1px solid #dcdfe6;
      margin-bottom: 5px;
      opacity: 0.5;
    }
    .el-tree-node__label {
      width: 160px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-left: 3px;
      margin-top: -2px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }
  }

  .comp-agency-tree-core {
    overflow-y: hidden;
    box-shadow: 0 0 0 0 rgba(6, 44, 82, 0.10), 0 2px 16px 0 rgba(33, 43, 54, 0.08) !important;
    .el-tree {
      margin-top: 5px;
      overflow-x: hidden;
      overflow-y: auto;
      position: relative;
      .disabled-text {
        color: #909399;
        cursor: not-allowed;
      }
      .el-checkbox__inner {
        transition: none;
        -webkit-transition: none;
      }
      .el-checkbox__inner::after {
        transition: none;
        -webkit-transition: none;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// AgencyTreeCore.vue?9c9e06a0